import React, { Component } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
//import { IMAGE_URL } from '../actions/types';
import { BASE_URL, IMAGE_URL } from "../actions/types";
import axios from "axios";
import { Card, CardImg, CardBody, CardTitle, Button } from "reactstrap";
class MainCarousel extends Component {
  state = { products: [], i: 1 };

  async componentDidMount() {
    const data = await axios.get(`${BASE_URL}/getRandom`);
    this.setState({ products: data.data });
  }

  getSlides = async () => {
    const update = this.state.i % 15;
    if (!update) {
      let data = await axios.get(`${BASE_URL}/getRandom`);
      const orig = this.state.products;
      const products = orig.concat(data.data);
      this.setState({ products });
    }
    this.setState({ i: this.state.i + 1 });
  };

  renderSlides = () => {
    if (this.state.products.length) {
      return this.state.products.map((p) => {
        const title = decodeURIComponent(p.name);
        return (
          <Card key={`/${p.parent}/${p.sub}/${p.name}`}>
            <img
              width="250"
              height="200"
              top
              className="sliderCard"
              src={`${IMAGE_URL}/360/${p.image}`}
              alt={p.name}
            />
            <CardBody>
              <CardTitle>
                {title} - {p.price}€
              </CardTitle>
              <Link to={`/${p.parent}/${p.sub}/${p.name}`}>
                <Button>Katso!</Button>
              </Link>
            </CardBody>
          </Card>
        );
      });
    }
  };

  render() {
    const settings = {
      arrows: false,
      centerMode: true,
      centerPadding: "60px",
      slidesToShow: 5,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
          },
        },
      ],
      afterChange: (index) => this.getSlides(),
    };

    if (this.state.products.length) {
      return <Slider {...settings}>{this.renderSlides()}</Slider>;
    } else return <div>Ladataan tuotteita....</div>;
  }
}
export default MainCarousel;
